import { isCanvasTheme, useTheme } from 'foundations-theming/utils';
import { ONBOARDING_COLOR } from './colors';
const PRIMARY_ON_FILL_MAP = {
  primary: 'primary-on-fill'
};
const CONTROL_ON_FILL_MAP = {
  primary: 'control-on-fill',
  secondary: 'control-on-fill',
  'secondary-ghost': 'control-on-fill',
  tertiary: 'control-on-fill',
  'tertiary-light': 'control-on-fill'
};
export const remapToPrimaryOnFill = use => {
  var _PRIMARY_ON_FILL_MAP;
  return (_PRIMARY_ON_FILL_MAP = PRIMARY_ON_FILL_MAP[use]) !== null && _PRIMARY_ON_FILL_MAP !== void 0 ? _PRIMARY_ON_FILL_MAP : use;
};
export const remapToControlOnFill = use => {
  var _CONTROL_ON_FILL_MAP;
  return (_CONTROL_ON_FILL_MAP = CONTROL_ON_FILL_MAP[use]) !== null && _CONTROL_ON_FILL_MAP !== void 0 ? _CONTROL_ON_FILL_MAP : use;
};
export const resolvePrimaryUse = ({
  use,
  isCanvas
}) => {
  var _PRIMARY_ON_FILL_MAP2;
  if (isCanvas) return 'primary-white';
  return (_PRIMARY_ON_FILL_MAP2 = PRIMARY_ON_FILL_MAP[use]) !== null && _PRIMARY_ON_FILL_MAP2 !== void 0 ? _PRIMARY_ON_FILL_MAP2 : use;
};
export const usePrimaryButtonStyle = ({
  use,
  disableColorRemap
}) => {
  const theme = useTheme();
  const isCanvas = isCanvasTheme(theme);
  return {
    use: disableColorRemap ? use : resolvePrimaryUse({
      use,
      isCanvas
    }),
    iconColor: isCanvas ? undefined : ONBOARDING_COLOR
  };
};